<script setup>
// T-252 · FILTRO POR CANAL E POR BIRA × HUMANO, o mesmo em todas as telas de relatório.
//
// Antes, cada tela tinha só o período. A pergunta "como está o Instagram" ou "o que é da IA"
// obrigava a ler o total e descontar de cabeça, o que ninguém faz direito duas vezes seguidas.
//
// ⚠️ NEM TODA TELA COMPORTA O RECORTE POR LADO, e por isso ele é opcional em vez de vir sempre.
// Em Atendimento IA, recortar por "humano" esvaziaria a tela com um filtro que parece ter
// funcionado; na Jornada, apagaria metade do caminho que ela existe para mostrar; em Detratores,
// a régua é sobre quem atendeu e o detrator é quem reclamou. Nesses casos a tela pede
// `com-lado="false"` e mostra só o canal.
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import SeletorLado from './SeletorLado.vue';

const props = defineProps({
  inboxId: { type: [Number, String], default: null },
  lado: { type: String, default: 'todos' },
  comLado: { type: Boolean, default: true },
});

const emit = defineEmits(['update:inboxId', 'update:lado']);

const { t } = useI18n();
const store = useStore();
const inboxes = useMapGetter('inboxes/getInboxes');

// A barra lateral já carrega as caixas, mas a tela de relatório pode ser aberta por link direto,
// e aí a lista chegaria vazia. Pedir de novo é barato e o store não refaz a chamada à toa.
onMounted(() => store.dispatch('inboxes/get'));

const lados = computed(() => [
  { key: 'todos', label: t('FILTROS_RELATORIO.LADO.TODOS') },
  { key: 'bira', label: t('FILTROS_RELATORIO.LADO.BIRA') },
  { key: 'humano', label: t('FILTROS_RELATORIO.LADO.HUMANO') },
]);

const aoTrocarCanal = evento => {
  const valor = evento.target.value;
  emit('update:inboxId', valor === '' ? null : Number(valor));
};
</script>

<template>
  <div class="flex flex-wrap items-center gap-3">
    <label class="flex items-center gap-2">
      <span class="text-xs font-medium text-n-slate-11">
        {{ t('FILTROS_RELATORIO.CANAL') }}
      </span>
      <select
        :value="inboxId ?? ''"
        class="h-8 py-0 mb-0 text-sm rounded-lg border-n-weak bg-n-solid-1 text-n-slate-12"
        @change="aoTrocarCanal"
      >
        <option value="">{{ t('FILTROS_RELATORIO.TODOS_OS_CANAIS') }}</option>
        <option v-for="caixa in inboxes" :key="caixa.id" :value="caixa.id">
          {{ caixa.name }}
        </option>
      </select>
    </label>

    <SeletorLado
      v-if="comLado"
      :model-value="lado"
      :opcoes="lados"
      :rotulo="t('FILTROS_RELATORIO.LADO.ROTULO')"
      @update:model-value="emit('update:lado', $event)"
    />
  </div>
</template>
